module.exports = __webpack_public_path__ + "img/BASC50.8b94164d.png";